// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".enterprise-title{color:#000;font-size:24px;font-weight:700;padding:60px 0 30px;display:flex;justify-content:space-between;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.enterprise-title>a{font-size:14px;font-weight:400;color:#222226}.enterprise-title>a:hover{color:#417ff9}.anchor{display:block;position:relative;top:-42px;visibility:hidden}", ""]);
// Exports
module.exports = exports;
